export const masterDataTypes = {
    API_RESPONSE_SUCCESS: '@@masterData/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@masterData/API_RESPONSE_ERROR',
    GET_ROLES:'@@masterData/GET_ROLES'
};
